import React from "react";
import { Card } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import './Services.css';

import marketbg from '../images/PageImg/ServiceMarket-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { ServMarketTopTxt } from "../assets/ServMarketData";
import { ServMarketTopImg } from "../assets/ServMarketData";
import { ServMarketImg } from "../assets/ServMarketData";
import { ServMarketTxt } from "../assets/ServMarketData";

import { GoTopBtn } from '../components/GoTopBtn';

function ServMarket() {
  // console.log("get into function ServMarket()");
  return (
    <div className='services-page container-fluid'>
      <div className='serviceheader'
        style={{ backgroundImage: `url(${marketbg})`, height: "60vh" }} >
        <HeaderSlide text={'Service / Marketing'} />
        <h4 className='text-light'>&nbsp;images/PageImg/ServiceMarket-page-bg.jpg</h4>
      </div>
      {/* <br /> */}

      {/* Service Marketing Top Iext */}
      <section id='servmarkettop' className='block service-block bg-primary-subtle mt-2'>
        <Container fluid> {
          // <Container className='holder d-flex' > {
          ServMarketTopTxt.map(top => {
            return (
              <Col key={top.id}>
                <br />
                <h2 className='m-1 fs-1 text-center text-primary'>{top.title}</h2>
                <p className='m-1 fs-3' style={{ whiteSpace: 'pre-wrap' }}>{top.text}</p>
              </Col>
            )
          })
        } </Container>
      </section>

      {/* Service Marketing Top Image */}
      <section id='servmarkettop' className='block service-block bg-success-subtle mt-2'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>Service Marketing</h2>
        <Container fluid>
          <Row className='d-flex justify-content-around'> {
            ServMarketTopImg.map(idx => {
              return (
                <Col lg={4} key={idx.id} className='flex'>
                  {/* <img src={idx.image} alt='' /> */}
                  <img src={idx.image} style={{ height: 'auto', width: '23vw' }} alt='' />
                  <h5 className='text-danger-emphasis'>{idx.alt}</h5>
                </Col>
              )
            })
          } </Row>
        </Container>
      </section>

      {/* Service Marketing */}
      <section id='servmarket' className='block service-block bg-primary-subtle'>
        {/* <Container fluid> */}
          <Row>
            <Col lg={4} className='flex-column'> {
              ServMarketImg.map(idx => {
                return (
                  <Row key={idx.id} className='d-flex'>
                    <img src={idx.image} style={{ height: 'auto' }} alt='' />
                    {/* <img style={{ height: '40vh' }} src={idx.image} alt='' /> */}
                    <h4 className='text-warning-emphasis'>{idx.alt}</h4>
                  </Row>
                )
              })
            } </Col>
            <Col lg={8} className='d-flex flex-column justify-content-around'> {
              <Row> {
                ServMarketTxt.map((market) => {
                  return (
                    <Row key={market.id} className='holder'>
                      <Card className='bg-discovery border-1 p-0 m-0'>
                        <br />
                        <Card.Title className='fs-2 text-center text-primary'> {market.title} </Card.Title>
                        <Card.Text style={{ whiteSpace: 'pre' }}> {market.text} </Card.Text>
                        {/* <Card.Text className='fs-4' style={{ whiteSpace: 'pre' }}> {market.text} </Card.Text> */}
                      </Card>
                    </Row>
                  )
                })
              } </Row>
            } </Col>
          </Row>
        {/* </ Container> */}
      </section>

      <div> < GoTopBtn /> </div>
    </div>
  );
}

export default ServMarket;

/* Service Marketing Header */
/* <Container className='d-flex justify-content-center align-items-center'> */
/*
<Container fluid className='d-flex'>
  <header className='mt-2'>
    <h1 className='servmarket'>Service / Marketing</h1>
    <h5 className='text-warning'>PageImg/services-page.jpg</h5>
    <h5 className='text-warning'>ServiceImg/MarketTop/ServMarket.jpg</h5>
  </header>
</Container>
*/
